/**
 * Component-specific logger that includes timestamp and unique ID
 */
export const createComponentLogger = (componentName: string) => {
  const startTime = Date.now();
  const instanceId = `${componentName}-${Math.random().toString(36).substr(2, 9)}`;

  return (message: string, data?: any) => {
    const elapsed = ((Date.now() - startTime) / 1000).toFixed(3);
    const prefix = `[${instanceId}] [+${elapsed}s]`;

    if (data !== undefined) {
      console.log(`${prefix} ${message}`, data);
    } else {
      console.log(`${prefix} ${message}`);
    }
  };
};
